import { Instance, types } from 'mobx-state-tree';
import { RegistrationDialogStore } from '../../dialogs/RegistrationDialogStore';
import { newOrderingStore, OrderingStore } from '../../pages/ordering/OrderingStore';

//ILLEGAL // "!app" //REOCTOBUILD

export const AppPageStores = types
	.model('AppPageStores', {
		orderingStore: types.optional(OrderingStore, newOrderingStore),
		registrationDialogStore: types.optional(RegistrationDialogStore, {}),
	});

export function newAppPageStores() : Instance<typeof AppPageStores> {
	return AppPageStores.create({});
}
